import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { LoginComponent } from './login/login.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { MenuComponent } from './menu/menu.component';
import { PaydoneComponent } from './paydone/paydone.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxPayPalModule } from 'ngx-paypal';
import { IndexComponent } from './index/index.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SecondPackComponent } from './second-pack/second-pack.component';
import { ChooseComponent } from './choose/choose.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ComicPackComponent } from './cosmic pack/components/comcic-pack/comic-pack.component';
import { ComicPackPayDoneComponent } from './cosmic pack/components/comic-pack-pay-done/comic-pack-pay-done.component';
import { SecondpaydoneComponent } from './secondpaydone/secondpaydone.component';
import { GalaDuoComponent } from './Gala Duo/gala-duo/gala-duo.component';
import { GalaDuoPayDoneComponent } from './Gala Duo/gala-duo-payDone/gala-duo-pay-done/gala-duo-pay-done.component';
import { MajorisComponent } from './Majoris/majoris/majoris.component';
import { MagorisPayDoneComponent } from './Majoris/majoris-payDone/magoris-pay-done/magoris-pay-done.component';
import { SultanaPackComponent } from './sultana-pack/sultana-pack.component';
import { SultanaPayDoneComponent } from './sultana-pay-done/sultana-pay-done.component';


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    LoginComponent,
    MenuComponent,
    PaydoneComponent,
    IndexComponent,
    SecondPackComponent,
    ChooseComponent,
    SecondpaydoneComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ComicPackComponent,
    ComicPackPayDoneComponent,
    GalaDuoComponent,
    GalaDuoPayDoneComponent,
    MajorisComponent,
    MagorisPayDoneComponent,
    SultanaPackComponent,
    SultanaPayDoneComponent,


  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    NgxPayPalModule,
    ClipboardModule



  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
